import {
  List,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
  EditButton,
  RaRecord,
} from 'react-admin'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import RoomServiceIcon from '@mui/icons-material/RoomService'
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox'
import FolderSharedIcon from '@mui/icons-material/FolderShared'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'

interface Conversation extends RaRecord {
  channel: string;
  contact_name?: string;
  subject?: string;
  employee_email?: string;
  status: string;
  created: string;
}

const channelIcons: Record<string, JSX.Element> = {
  phone: <LocalPhoneIcon fontSize="small" />,
  counter: <RoomServiceIcon fontSize="small" />,
  mail: <MarkunreadMailboxIcon fontSize="small" />,
  person: <FolderSharedIcon fontSize="small" />,
  email: <AlternateEmailIcon fontSize="small" />,
  social: <ThumbUpIcon fontSize="small" />,
}

const ConversationList = () => (
  <List
    filter={{ status: 'active' }}
    sort={{ field: 'created', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid rowClick="edit">
      <FunctionField<Conversation>
        label="Kanaal"
        render={(record) =>
          (record ? channelIcons[record.channel] : null) || (
            <LocalPhoneIcon fontSize="small" />
          )
        }
      />
      <FunctionField<Conversation>
        label="Contact"
        render={(record) => record?.contact_name || 'Anoniem'}
      />
      <TextField source="subject" label="Onderwerp" />
      <TextField source="employee_email" label="Medewerker" />
      <TextField source="status" label="Status" />
      <DateField source="created" label="Aangemaakt" showTime />
      <EditButton />
    </Datagrid>
  </List>
)

export default ConversationList
